export const homeKeys = {
  all: ['home'] as const,
  coach: (uid?: string) => [...homeKeys.all, 'coach', uid] as const,
  academy: (academyId?: string | null) => [...homeKeys.all, 'academy', academyId] as const,
} as const;
